import React, { useEffect, useState } from 'react';
import { Drawer, Button, Panel, Checkbox, DatePicker, Input, useToaster, Message } from 'rsuite';
import { FaCalendar } from 'react-icons/fa';
import ArrowRightLineIcon from '@rsuite/icons/ArrowRightLine';
import './styles.css';
import { useFormik } from 'formik';
import { useLocation } from 'react-router-dom';
import globalIP from '../../GlobelIP';
import GenerateAccess from './GenerateAccess';
import GenerateMobileAccess from './GenerateMobileAccess';
import axios from 'axios';
import deviveIp from '../../../deviceIp';
import { handleDecrypt, handleEncrypt } from '@/functions';
import ugr from '@/UGRoute';
export default function GenerateAuthSlider({ open, close, setLinkGenrate, setShowCopyButton, selectedCatalogueCode = "" }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const catalogueName = searchParams.get('cataloguename');
  const cataloguecode = searchParams.get('cataloguecode');
  console.log(cataloguecode, selectedCatalogueCode)
  const [activeButton, setActiveButton] = useState(1);
  const [access, setAccess] = useState(false);
  const [access2, setAccess2] = useState(false);
  const [catalogueData, setCatalogueData] = useState();
  const [catalogueMeta, setCatalogueMeta] = useState();
  const [emailList, setEmailList] = useState([]);
  const [mobileList, setMobileList] = useState([]);
  const [linkCheckBox, setLinkCheckBox] = useState(false);
  const [emailRestricCheckbox, setEmailRestricCheckbox] = useState(false);
  const [mobileRestricCheckbox, setMobileRestricCheckbox] = useState(false);
  const toaster = useToaster();
  useEffect(() => {
    fetchDatacatadata();
  }, [open]);
  const generateClintCode = () => {
    const nextCode = catalogueMeta?.pagination.total + 1;
    return `CLI-${nextCode.toString().padStart(3, '0')}`;
  };
  useEffect(() => {
    if (catalogueData) {
      const { attributes } = catalogueData;
      formik.setValues({
        ...formik.values,
        buyercode: attributes.BuyerName,
        typecode: attributes.CatalogueCode,
        typename: attributes.catalogueName,
        Timefrom: new Date()
      });
      const client_id = generateClintCode();
      formik.setFieldValue('client_id', client_id);
    }
  }, [catalogueData]);

  const fetchDatacatadata = async () => {
    const response = await fetch(
      `${globalIP}/api/catalogues?populate=*&filters[CatalogueCode][$eq]=${cataloguecode ?? selectedCatalogueCode}`
    );
    const response1 = await fetch(`${globalIP}/api/catalogues?populate=*`);
    const { data } = await response.json();
    const json1 = await response1.json();
    setCatalogueData(data[0]);
    setCatalogueMeta(json1.meta);
  };
  function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
  const Submit = async (value, action) => {
    const userid = localStorage.getItem('id')
    const randomString = generateRandomString(50);
    const data = await axios.post(`${globalIP}/api/client-logins?populate=*`, {
      data: {
        ...value,
        userid: userid,
        loginemailid: emailList.length ? emailList : [],
        loginmobile: mobileList.length ? mobileList : []
      }
    });

    const encodedId = handleEncrypt(data.data?.data?.id);
    const encodedCatId = handleEncrypt(catalogueData?.id);
    const generatedLink = `/${ugr}/client/apptwo?Key=${randomString}&id=${encodedId}&Cat_id=${encodedCatId}`;

    const data_1 = await axios.put(`${globalIP}/api/catalogues/${catalogueData?.id}`, {
      data: { Glink: generatedLink }
    });
    setLinkGenrate(generatedLink);
    if (data.statusText == 'OK') {
      action.resetForm();
      notify('Updated Successfully', '', 'success');
      close();
      setShowCopyButton(true);
    } else {
      console.error('Something is wrong');
    }
  };

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      bypassword: false,
      byemail: false,
      emailotp: false,
      bymobile: false,
      mobileotp: false,
      downloadppt: false,
      showfilter: false,
      setasdefault: false,
      buyername: '',
      buyercode: '',
      typecode: '',
      typename: '',
      client_id: '',
      Type: 'Catalogue',
      Status: 'Active',
      SlideShow: false,
      SmartSearch: false,
      visualProduct: false
    },
    onSubmit: async (value, action) => {
      const submitForm = async () => {
        await Submit(value, action);
      };
      if (value.byemail && value.bymobile && value.bypassword) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (mobileRestricCheckbox) {
              if (mobileList.length) {
                if (value.username && value.password) {
                  if (linkCheckBox && value.Timeto) {
                    await submitForm();
                  } else {
                    notify('Link Expiry date is required!');
                  }
                } else {
                  notify('Fill username and password');
                }
              } else {
                notify('Add at least one mobile number!');
              }
            } else {
              notify('Mobile Restrict is required');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.byemail && value.bymobile) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (mobileRestricCheckbox) {
              if (mobileList.length) {
                if (linkCheckBox && value.Timeto) {
                  await submitForm();
                } else {
                  notify('Link Expiry date is required!');
                }
              } else {
                notify('Add at least one mobile number!');
              }
            } else {
              notify('Mobile Restrict is required');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.byemail && value.bypassword) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (value.username && value.password) {
              if (linkCheckBox && value.Timeto) {
                await submitForm();
              } else {
                notify('Link Expiry date is required!');
              }
            } else {
              notify('Fill username and password');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.bymobile && value.bypassword) {
        if (mobileRestricCheckbox) {
          if (mobileList.length) {
            if (value.username && value.password) {
              if (linkCheckBox && value.Timeto) {
                await submitForm();
              } else {
                notify('Link Expiry date is required!');
              }
            } else {
              notify('Fill username and password');
            }
          } else {
            notify('Add at least one mobile number!');
          }
        } else {
          notify('Mobile Restrict is required');
        }
      } else if (value.byemail) {
        if (emailRestricCheckbox) {
          if (emailList.length) {
            if (linkCheckBox && value.Timeto) {
              await submitForm();
            } else {
              notify('Link Expiry date is required!');
            }
          } else {
            notify('Add at least one email!');
          }
        } else {
          notify('Email Restrict is required');
        }
      } else if (value.bymobile) {
        if (mobileRestricCheckbox) {
          if (mobileList.length) {
            if (linkCheckBox && value.Timeto) {
              await submitForm();
            } else {
              notify('Link Expiry date is required!');
            }
          } else {
            notify('Add at least one mobile number!');
          }
        } else {
          notify('Mobile Restrict is required');
        }
      } else if (value.bypassword) {
        const checkUserName = await axios.get(
          `${globalIP}/api/client-logins?populate=*&filters[username][$eq]=${value.username}`
        );

        if (!checkUserName.data.data.length) {
          if (value.username && value.password) {
            if (linkCheckBox && value.Timeto) {
              await submitForm();
            } else {
              notify('Link Expiry date is required!');
            }
          } else {
            notify('Fill username and password');
          }
        } else {
          notify('Username already taken');
        }
      } else if (linkCheckBox && value.Timeto) {
        await submitForm();
      } else {
        notify('Link Expiry date is required!');
      }
    }
  });
  const notify = (message, placement?, type?) => {
    toaster.push(
      <Message showIcon type={type || 'error'}>
        {message}
      </Message>,
      { placement: placement || 'topEnd' }
    );
  };
  const handleCheckboxChange = (name, value) => {
    if (name == 'bypassword' && !!value) {
      formik.setFieldValue('username', '');
      formik.setFieldValue('password', '');
    }
    formik.setFieldValue(name, !value);
  };
  const handleLinkCheckBox = value => {
    setLinkCheckBox(value);
    if (!value) {
      formik.setFieldValue('Timeto', '');
    }
  };
  const handleEmailCheckBox = value => {
    setEmailRestricCheckbox(value);
    if (!value) {
      setEmailList([]);
    }
  };
  const handleMobileCheckBox = value => {
    setMobileRestricCheckbox(value);
    if (!value) {
      setMobileList([]);
    }
  };

  return (
    <>
      <Drawer open={open} onClose={close} size="xs" backdrop="static">
        <Drawer.Header>
          <Drawer.Title>Link security</Drawer.Title>
        </Drawer.Header>
        <Drawer.Body>
          <Drawer.Actions
            className="Privacy-header"
            style={{ textAlign: 'left', padding: '10px 0', gap: '20px', display: 'flex' }}
          >
            {[1, 2].map(buttonNumber => (
              <Button
                key={buttonNumber}
                appearance={activeButton === buttonNumber ? 'primary' : 'default'}
                onClick={() => setActiveButton(buttonNumber)}
                color="cyan"
              >
                {buttonNumber === 1 ? 'Privacy Control' : 'Display Settings'}
              </Button>
            ))}
          </Drawer.Actions>
          <form onSubmit={formik.handleSubmit}>
            {activeButton === 1 ? (
              <PrivacyControlForm
                formik={formik}
                handleCheckboxChange={handleCheckboxChange}
                setAccess2={setAccess2}
                setAccess={setAccess}
                linkCheckBox={linkCheckBox}
                handleLinkCheckBox={handleLinkCheckBox}
                handleEmailCheckBox={handleEmailCheckBox}
                emailRestricCheckbox={emailRestricCheckbox}
                mobileRestricCheckbox={mobileRestricCheckbox}
                handleMobileCheckBox={handleMobileCheckBox}
                setEmailList={setEmailList}
                setEmailRestricCheckbox={setEmailRestricCheckbox}
                setMobileList={setMobileList}
                setMobileRestricCheckbox={setMobileRestricCheckbox}
                mobileList={mobileList}
              />
            ) : (
              <DisplaySettingsForm formik={formik} handleCheckboxChange={handleCheckboxChange} />
            )}
          </form>
        </Drawer.Body>
      </Drawer>
      {access && (
        <GenerateAccess
          open={access}
          close={() => setAccess(false)}
          typeCode={formik?.values?.typecode}
          emailList={emailList}
          setEmailList={setEmailList}
        />
      )}
      {access2 && (
        <GenerateMobileAccess
          open={access2}
          close={() => setAccess2(false)}
          typeCode={formik?.values?.typecode}
          mobileList={mobileList}
          setMobileList={setMobileList}
        />
      )}
    </>
  );
}

const PrivacyControlForm = ({
  formik,
  handleCheckboxChange,
  setAccess,
  linkCheckBox,
  handleLinkCheckBox,
  setAccess2,
  handleEmailCheckBox,
  emailRestricCheckbox,
  mobileRestricCheckbox,
  handleMobileCheckBox,
  setEmailList,
  setEmailRestricCheckbox,
  setMobileList,
  setMobileRestricCheckbox,
  mobileList
}) => (
  <div className="Privacy-tab">
    <div style={{ marginBottom: '100px' }}>
      <Panel shaded>
        <Checkbox
          value={formik.values.bypassword}
          checked={formik.values.bypassword}
          name="bypassword"
          onChange={() => handleCheckboxChange('bypassword', formik.values.bypassword)}
        >
          User Id
        </Checkbox>
        <div
          className="GAuthPrivacy-date"
          style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}
        >
          <Input
            placeholder="Enter Username"
            onChange={value => {
              const replacedValue = value.replace(/\s+/g, ' ');
              const trimmedValue = replacedValue.startsWith(' ')
                ? replacedValue.slice(1)
                : replacedValue;
              formik.setFieldValue('username', trimmedValue);
            }}
            value={formik.values.username}
            name="username"
            disabled={!formik.values.bypassword}
          />
          <Input
            placeholder="Enter Password"
            value={formik.values.password}
            onChange={value => formik.setFieldValue('password', value.trim())}
            name="password"
            disabled={!formik.values.bypassword}
          />
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          value={linkCheckBox}
          name="byLink"
          checked={linkCheckBox}
          onChange={() => handleLinkCheckBox(!linkCheckBox)}
        >
          Link expires on
        </Checkbox>
        <div className="note-left">
          Link will be automatically deactivated after the selected date
        </div>
        <div className="GAuthPrivacy-date">
          <DatePicker
            format="dd MMM yyyy hh:mm:ss aa"
            placement="leftEnd"
            showMeridian
            caretAs={FaCalendar}
            style={{ width: '100%' }}
            value={formik.values.Timeto}
            onChange={value => formik.setFieldValue('Timeto', value)}
            disabled={!linkCheckBox}
          />
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          name="byemail"
          value={formik.values.byemail}
          checked={formik.values.byemail}
          onChange={() => {
            formik.values.byemail && setEmailList([]);
            formik.values.byemail && setEmailRestricCheckbox(false);
            handleCheckboxChange('byemail', formik.values.byemail);
            formik.setFieldValue('emailotp', !formik.values.emailotp);
          }}
        >
          Email Required to view catalogue
        </Checkbox>
        <div className="GAuthPrivacy">
          <div>
            <Checkbox
              name="emailotp"
              value={formik.values.emailotp}
              checked={formik.values.emailotp}
              disabled={!formik.values.byemail}
            >
              OTP verification required
            </Checkbox>
            <div className="note-left">
              Viewer must verify their email via OTP to access your catalogue
            </div>
          </div>
          <div>
            <Checkbox
              disabled={!formik.values.byemail}
              value={emailRestricCheckbox}
              checked={emailRestricCheckbox}
              onChange={() => handleEmailCheckBox(!emailRestricCheckbox)}
            >
              Restrict Access
            </Checkbox>
          </div>
          <div className="note-left">1 email Allowed</div>
          <div className="note-left">
            <button
              onClick={() => setAccess(true)}
              type="button"
              disabled={!formik.values.byemail || !formik.values.emailotp || !emailRestricCheckbox}
            >
              Allow or block specific users <ArrowRightLineIcon />
            </button>
          </div>
        </div>
      </Panel>
      <Panel shaded>
        <Checkbox
          name="bymobile"
          checked={formik.values.bymobile}
          value={formik.values.bymobile}
          onChange={() => {
            formik.values.bymobile && setMobileList([]);
            formik.values.bymobile && setMobileRestricCheckbox(false);
            handleCheckboxChange('bymobile', formik.values.bymobile);
            formik.setFieldValue('mobileotp', !formik.values.mobileotp);
          }}
        >
          Phone number is required to view catalogue
        </Checkbox>
        <div className="GAuthPrivacy">
          <Checkbox
            name="mobileotp"
            value={formik.values.mobileotp}
            checked={formik.values.mobileotp}
            disabled={!formik.values.bymobile}
          >
            OTP verification required
          </Checkbox>
          <br />
          <div className="note-left">Verify Phone no to make Catalogue visible</div>
          <div>
            <Checkbox
              disabled={!formik.values.mobileotp}
              value={mobileRestricCheckbox}
              checked={mobileRestricCheckbox}
              onChange={() => handleMobileCheckBox(!mobileRestricCheckbox)}
            >
              {' '}
              Restrict Access
            </Checkbox>
          </div>
          <div className="note-left">
            {mobileList?.length ? mobileList.filter(item => item.mobilests == true).length : 0}
            {'  '}
            mobile no Allowed
          </div>
          <div className="note-left">
            <button
              onClick={() => setAccess2(true)}
              type="button"
              // disabled={!formik.values.mobileotp}
              disabled={
                !formik.values.mobileotp || !formik.values.bymobile || !mobileRestricCheckbox
              }
            >
              Allow or block specific users <ArrowRightLineIcon />
            </button>
          </div>
        </div>
      </Panel>
    </div>
    <PrivacyFooter formik={formik} handleCheckboxChange={handleCheckboxChange} />
  </div>
);

const DisplaySettingsForm = ({ formik, handleCheckboxChange }) => (
  <div className="Privacy-tab">
    <Panel shaded>
      <Checkbox
        name="downloadppt"
        value={formik.values.downloadppt}
        checked={formik.values.downloadppt}
        onChange={() => handleCheckboxChange('downloadppt', formik.values.downloadppt)}
      >
        Download PPT
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="showfilter"
        value={formik.values.showfilter}
        checked={formik.values.showfilter}
        onChange={() => handleCheckboxChange('showfilter', formik.values.showfilter)}
      >
        Show Filters
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="SlideShow"
        value={formik.values.SlideShow}
        checked={formik.values.SlideShow}
        onChange={() => handleCheckboxChange('SlideShow', formik.values.SlideShow)}
      >
        SlideShow
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="SmartSearch"
        value={formik.values.SmartSearch}
        checked={formik.values.SmartSearch}
        onChange={() => handleCheckboxChange('SmartSearch', formik.values.SmartSearch)}
      >
        Smart Search
      </Checkbox>
    </Panel>
    <Panel shaded>
      <Checkbox
        name="visualProduct"
        value={formik.values.visualProduct}
        checked={formik.values.visualProduct}
        onChange={() => handleCheckboxChange('visualProduct', formik.values.visualProduct)}
      >
        Space Visualization
      </Checkbox>
    </Panel>
    <PrivacyFooter formik={formik} handleCheckboxChange={handleCheckboxChange} />
  </div>
);

const PrivacyFooter = ({ formik, handleCheckboxChange }) => (
  <Panel shaded className="Privacy-footer">
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <Checkbox
        name="setasdefault"
        value={formik.values.setasdefault}
        checked={formik.values.setasdefault}
        onChange={() => handleCheckboxChange('setasdefault', formik.values.setasdefault)}
      >
        Set as Default
      </Checkbox>
      <Button appearance="primary" type="submit" color="cyan">
        Create Link
      </Button>
    </div>
  </Panel>
);
